/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var EduHatIcon24Solid = forwardRef('EduHatIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.89 3.151a4.652 4.652 0 0 0-3.78 0L.95 7.281c-1.272.572-1.264 2.2.01 2.765l9.176 4.064c1.173.52 2.555.52 3.729 0L21 10.95v3.614a1.75 1.75 0 1 0 2 0v-4.5l.04-.018c1.274-.565 1.282-2.193.01-2.766l-9.16-4.129Z" }),
        React.createElement("path", { d: "M5 13.335V17c0 2.5 3.5 4 7 4s7-1.5 7-4v-3.665l-5.136 2.275a4.654 4.654 0 0 1-3.729 0L5 13.335Z" })));
});
